import { makeStyles, withStyles } from "@material-ui/core/styles";
import { InputBase } from "@material-ui/core";
import { lighten, darken } from "polished";
import {
  secondary,
  grey300,
  white,
} from "../../../../../../../../../assets/variables.module.scss";

const useStyles = makeStyles((theme) => ({
  checkbox: {
    "&:hover": { backgroundColor: "transparent" },
    "& svg": {
      color: secondary,
    },
  },
  disabled: {
    backgroundColor: darken(0.2, grey300),
    color: grey300,
  },
  modifierContainer: {
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(2),
  },
  searchContainer: {
    marginBottom: theme.spacing(2),
    height: 32,
  },
  searchButton: {
    height: 32,
    backgroundColor: secondary,
    color: white,
    fontWeight: 500,
    borderRadius: "0 16px 16px 0",
    paddingRight: theme.spacing(2),
    textTransform: "none",

    "&:hover": {
      backgroundColor: lighten(0.1, secondary),
    },
  },
  searchIcon: {
    marginLeft: theme.spacing(1),
  },
}));

export const CustomInput = withStyles((theme) => ({
  root: {
    "& svg": {
      color: secondary,
    },
  },
  input: {
    color: secondary,
    border: "none",
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    fontSize: theme.typography.body1,
    padding: "10px 26px 10px 12px",
    "&:focus": {
      border: "none",
    },
  },
}))(InputBase);

export default useStyles;
